import React, { createContext, useState, useMemo, useCallback } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Text, Space, ModalContainer } from '@redlink/components/atoms';
import { Button } from '@redlink/components/molecules';
import { useLocale } from '@redlink/assets/locale';

export const DialogContext = createContext({});

export const DialogProvider = ({ children }) => {
  const { styles } = useStyle();
  const { dictionary } = useLocale();
  const [isVisible, setIsVisible] = useState(false);
  const [dialogData, setDialogData] = useState({});

  const DialogContextValue = useMemo(
    () => ({
      showConfirmDialog: (data) => {
        setDialogData(data);
        setIsVisible(true);
      },
    }),
    []
  );

  const { message, onConfirm } = dialogData;

  const onConfirmPressed = useCallback(() => {
    setIsVisible(false);
    onConfirm && onConfirm();
  }, [onConfirm]);

  return (
    <DialogContext.Provider value={DialogContextValue}>
      <View style={styles.mainContainer}>
        {children}
        {isVisible && (
          <ModalContainer
            visible={isVisible}
            animationType="fade"
            transparent
            onRequestClose={() => setIsVisible(false)}
            style={styles.modalContainer}
          >
            <View style={styles.container}>
              <View style={styles.dialogContainer}>
                <Text style={styles.messageText}>{message}</Text>
                <Space size={24} />
                <View style={styles.actionsContainer}>
                  <Button
                    style={styles.actionContainer}
                    title={dictionary.no}
                    onPress={() => setIsVisible(false)}
                  />
                  <Space />
                  <Button
                    style={styles.actionContainer}
                    variant="primary"
                    title={dictionary.yes}
                    onPress={onConfirmPressed}
                  />
                </View>
              </View>
            </View>
          </ModalContainer>
        )}
      </View>
    </DialogContext.Provider>
  );
};

const useStyle = createUseStyle(({ colors, size, shadow }) => ({
  mainContainer: {
    flex: 1,
  },
  container: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  dialogContainer: {
    backgroundColor: colors.white,
    borderRadius: 20,
    padding: 24,
    minWidth: 300,
  },
  actionsContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  actionContainer: {
    flex: 1,
  },
  modalContainer: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  messageText: {
    color: colors.black
  }
}));
